exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".language-selection__wrapper[data-v-60bcff9e]{background-color:#fff;border:1px solid #f1eeea;padding:50px 30px}.language-selection__title[data-v-60bcff9e]{color:#1d1d1d;font-size:21px;font-weight:700;margin-bottom:30px;margin-top:0;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-60bcff9e","scoped":true,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/main-survey/language-selection.vue
// module id = 856
// module chunks = 0